<template>
    <div class="movie-index home-page page">
        <div class="head">
            <div class="region flex" @click="toSetCity">
                <span>{{ cityName }}</span>
                <img class="img" :src="require('@/assets/icons/icon-down.png')" />
            </div>
            <div class="search" @click="toSearch">
                <img class="img" :src="require('@/assets/icons/icon-search.png')" />
                <span class="txt">请输入关键词搜索</span>
            </div>
        </div>
        <div class="swiper-box" v-if="!bannerImgs.length == 0">
            <div class="swiper-container banner-swiper swiper-container-autoheight">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in bannerImgs" :key="index">
                        <img class="swiper-img" :src="item.imageUrl" alt="" />
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
        <div class="member" v-if="!iconList.length == 0">
            <div class="wrap">
                <div
                    class="cell"
                    v-for="(item, index) in iconList"
                    :key="index"
                    @click="clickIcon(item)"
                >
                    <div class="cell-item">
                        <img class="img" :src="item.imageUrl" />
                        <div class="name">
                            <span class="txt">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav">
            <div class="wrap">
                <div
                    class="hot cell"
                    :class="{ active: movieIndexStatus == 0 }"
                    @click="switchMovieStatus(0)"
                >
                    <span class="txt">正在热映</span>
                </div>
                <div
                    class="come cell"
                    :class="{ active: movieIndexStatus == 1 }"
                    @click="switchMovieStatus(1)"
                >
                    <span class="txt">即将上映</span>
                </div>
            </div>
        </div>
        <div class="list">
            <div class="wrap">
                <div
                    class="cell"
                    v-for="(item, index) in movieList"
                    @click="toMovieInfo(item)"
                    :key="index"
                >
                    <div class="c-left">
                        <img class="img" :src="item.pic" />
                    </div>
                    <div class="c-center">
                        <div class="cchd">
                            <div class="cinema">{{ item.name }}</div>
                            <div
                                class="hint"
                                :class="{ highlight: item.d != '' && item.d != '2D' }"
                                v-if="item.d != '' || item.im != ''"
                            >
                                <span class="txt treed" v-if="item.d">{{ item.d }}</span>
                                <span class="txt imax" v-if="item.im">{{ item.im }}</span>
                            </div>
                        </div>
                        <div class="grade">
                            <template v-if="Number(item.grade) > 0">
                                <span class="txt grade-title">评分</span>
                                <span class="txt tint">{{ item.grade }}</span>
                            </template>
                            <template v-if="Number(item.like) > 0">
                                <span class="txt tint">{{ item.likeText }}</span>
                                <span class="txt">人想看</span>
                            </template>
                        </div>
                        <div class="director">
                            <span class="txt">导演：{{ item.director }}</span>
                        </div>
                        <div class="lead">
                            <span class="txt actors">主演：{{ item.cast }}</span>
                        </div>
                        <div class="time">
                            <span class="txt">{{ item.filmType }} {{ item.duration }}分钟</span>
                        </div>
                    </div>
                    <div class="c-right" :class="{ 'pre-sale': item.status == 0 }">
                        {{ item.status == 0 ? '预售' : '购票' }}
                    </div>
                </div>
                <!-- <div class="noList">暂无电影信息</div> -->
            </div>
        </div>
        <Scroll :onBottom="onBottom" :lowerThreshold="200" />
        <Share v-if="!$store.state.common.platformId"></Share>
    </div>
</template>
<script>
import moment from 'moment';
import Swiper from '@/lib/swiper3.4.2/swiper.min.js';
import '@/lib/swiper3.4.2/swiper.min.css';
import Scroll from '@/components/scroll';
import Share from '@/components/share';
import { GET_BANNER_OR_ICON, GET_HOST_MOVIE_LIST, GET_MOVIE_LIST } from 'api';
import { PAGE_MOVIE_INFO, PAGE_SET_CITY, PAGE_MAIN_CINEMA, PAGE_ORDER_INFO } from 'page';
import { QZ_INDEX_ICON_LIST } from 'constant';
import number from '@/lib/number';

export default {
    data() {
        return {
            isInit: false,
            isFrist: true,
            isLoadingList: false,
            requestId: 0,
            bannerImgs: [],
            iconList: QZ_INDEX_ICON_LIST(),
            movieIndexStatus: 0,
            pageIndex: 1,
            pageSize: 20,
            movieList: [],
            isBottom: false,
            bannerSwiper: null,
            isOpenBack: false,
        };
    },
    components: {
        Scroll,
        Share,
    },
    computed: {
        cityName() {
            return this.$store.getters.getCurrentLocation.city.name || '未定位';
        },
        cityId() {
            return this.$store.getters.getCurrentLocation.city.id || 0;
        },
        movieBannerList() {
            return this.$store.getters.getExposeMethod.movieBannerList || [];
        },
        platformHomeTip10536() {
            return this.$store.getters.getExposeMethod.platformHomeTip10536;
        },
    },
    watch: {
        cityId() {
            if (!this.isLoadingList && (!this.isInit || !this.isFrist)) {
                this.isInit = true;
                this.pageIndex = 1;
                this.movieList = [];
                this.getList();
            } else if (this.cityId) {
                // 使旧城市尚未返回的请求失效，结束后再补发当前城市请求。
                this.requestId++;
                this.isLoadingList = false;
                this.pageIndex = 1;
                this.movieList = [];
                this.getList();
            }
        },
        movieBannerList(val) {
            console.log('watch', 'movieBannerList');
            if (val.length > 0) {
                this.setPlatformBanner();
            }
        },
        platformHomeTip10536(val) {
            console.log(val);
            if (val) {
                this.$confirm.open({
                    title: '购票提示',
                    message:
                        '尊敬的客户，您好！为了保证您的观影体验，请在电影开场前90分钟完成购票，确认好场次和时间，购买成功后将不予退还。',
                    hideCancelBtn: true,
                    confirmText: '我知道了',
                });
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.movieList.length == 0) {
                vm.$util.debounce(vm.init)();
            }
        });
    },
    created() {
        this.$util.debounce(this.init)();
        if (this.$store.getters.getExposeMethod.platformHomeTip10536) {
            this.$confirm.open({
                title: '购票提示',
                message:
                    '尊敬的客户，您好！为了保证您的观影体验，请在电影开场前90分钟完成购票，确认好场次和时间，购买成功后将不予退还。',
                hideCancelBtn: true,
                confirmText: '我知道了',
            });
        }
    },
    methods: {
        init() {
            this.bannerImgs = [];
            this.setPlatformBanner();
            this.getBanner();
            if (this.cityId) {
                this.isInit = true;
                this.pageIndex = 1;
                this.movieList = [];
                this.getList();
            }
        },
        // 获取电影列表
        getList() {
            if (this.isLoadingList || !this.cityId) {
                return Promise.resolve();
            }
            this.isLoadingList = true;
            const requestId = ++this.requestId;
            let requestUrl = '';
            if (this.movieIndexStatus == 0) {
                requestUrl = GET_HOST_MOVIE_LIST;
            } else {
                requestUrl = GET_MOVIE_LIST;
            }
            this.$util
                .post(requestUrl, {
                    cityId: this.cityId,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    status: this.movieIndexStatus == 0 ? 1 : 0,
                    publishDateBeginTime: moment().format('yyyy-MM-DD 00:00:00'),
                    cinemaShowType: this.$store.getters.getExposeMethod.cinemaShowType || null,
                })
                .then(res => {
                    if (requestId != this.requestId) {
                        return;
                    }
                    if (res.success) {
                        if (res.data.length < this.pageSize) {
                            this.isBottom = true;
                        } else {
                            this.isBottom = false;
                        }
                        if (this.movieIndexStatus == 0) {
                            this.isBottom = true;
                        }
                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            if (!item.versionTypes) {
                                item.d = '';
                                item.im = '';
                            } else {
                                if (item.versionTypes.split(' ').length == 2) {
                                    item.d = item.versionTypes.split(' ')[0];
                                    item.im = item.versionTypes.split(' ')[1];
                                } else {
                                    if (item.versionTypes.indexOf('5D') >= 0) {
                                        item.d = '5D';
                                    } else if (item.versionTypes.indexOf('4D') >= 0) {
                                        item.d = '4D';
                                    } else if (item.versionTypes.indexOf('3D') >= 0) {
                                        item.d = '3D';
                                    } else if (item.versionTypes.indexOf('2D') >= 0) {
                                        item.d = '2D';
                                    } else {
                                        item.d = '';
                                    }
                                    if (item.versionTypes.indexOf('IMAX') >= 0) {
                                        item.im = 'IMAX';
                                    } else if (item.versionTypes.indexOf('中国巨幕') >= 0) {
                                        item.im = '中国巨幕';
                                    } else {
                                        item.im = '';
                                    }
                                }
                            }
                            if (item.like) {
                                if (item.like > 10000) {
                                    item.likeText =
                                        (1 * number.operation(`${item.like}/10000`)).toFixed(2) +
                                        '万';
                                } else {
                                    item.likeText = item.like.toLocaleString();
                                }
                            }
                        }
                        this.movieList = [...this.movieList, ...res.data];
                    }
                    this.isFrist = false;
                    this.isLoadingList = false;
                });
        },
        // 获取banner
        getBanner() {
            this.$util.get(`${GET_BANNER_OR_ICON}/${30}`).then(res => {
                if (res.success) {
                    this.bannerImgs = [...this.bannerImgs, ...res.data];
                    this.setBannerSwiper();
                }
            });
        },
        setBannerSwiper() {
            if (this.bannerImgs.length == 0) return;
            this.$nextTick(() => {
                // debugger;
                if (this.bannerSwiper) {
                    this.bannerSwiper.destroy(true, true);
                    this.bannerSwiper = null;
                    // this.bannerSwiper.update();
                    // this.bannerSwiper.reLoop();
                }
                
                this.bannerSwiper = new Swiper('.banner-swiper', {
                    direction: 'horizontal' /*横向滑动*/,
                    autoplay: 3000,
                    autoHeight: true,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    onClick: swiper => {
                        this.clickBannerItem(this.bannerImgs[swiper.realIndex]);
                    },
                });
                if (this.bannerSwiper && this.bannerImgs.length > 1) {
                    this.bannerSwiper.startAutoplay();
                } else {
                    this.bannerSwiper.stopAutoplay();
                }
            });
        },
        clickBannerItem(item) {
            if (item.path) {
                window.location.href = item.path;
            }
        },
        setPlatformBanner() {
            let bannerList = this.$store.getters.getExposeMethod.movieBannerList || [];
            let tempBannerImgs = [];
            let nowTime = new Date().getTime();
            for (let i = 0; i < bannerList.length; i++) {
                const item = bannerList[i];
                if (item.startTime <= nowTime && nowTime <= item.endTime) {
                    tempBannerImgs.push(item);
                }
            }
            this.bannerImgs = [...tempBannerImgs, ...this.bannerImgs];
            this.setBannerSwiper();
        },
        // 点击 icon
        clickIcon(item) {
            if (item.type == 3 && item.path) {
                return (window.location.href = item.path);
            } else if (item.path) {
                return this.$util.pageJump(item.path, item.extraParam);
            } else if (item.message) {
                return this.$toast(item.message);
            }
        },
        // 切换电影状态
        switchMovieStatus(index) {
            if (this.movieIndexStatus != index) {
                this.movieIndexStatus = index;
                this.pageIndex = 1;
                this.movieList = [];
                this.getList();
            }
        },
        // 去电影详情
        toMovieInfo(item) {
            this.$util.pageJump(PAGE_MOVIE_INFO, {
                titleName: item.name,
                movieId: item.id,
            });
        },
        // 去设置城市
        toSetCity() {
            this.$util.pageJump(PAGE_SET_CITY);
        },
        // 去搜索
        toSearch() {
            this.$util.pageJump(PAGE_MAIN_CINEMA, { type: 1 });
        },
        //防止页面后退
        fobiddeBack() {
            if (!this.isOpenBack) {
                console.log('%c防止页面后退', 'color:#da2f33');
                this.isOpenBack = true;
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.backCommon);
            }
        },
        //启用浏览器返回
        enableBack() {
            if (this.isOpenBack) {
                console.log('%c启用浏览器返回', 'color:#da2f33');
                this.isOpenBack = false;
                history.go(-1);
                window.removeEventListener('popstate', this.backCommon);
                window.history.go(1);
            }
        },
        backCommon() {
            this.$util.closeWindow();
            history.pushState(null, null, document.URL);
        },
        // 触底事件
        onBottom() {
            if (this.isBottom || this.isLoadingList) {
                return;
            }
            this.pageIndex++;
            this.getList();
        },
    },
};
</script>
<style>
.movie-index .swiper-pagination-bullet-active {
    background: #333333 !important;
}
</style>

<style lang="less" scoped>
@import url('~@/lib/base.less');
.home-page {
    line-height: 1 !important;
    .head {
        display: flex;
        flex-direction: row;
        padding: .pxToRem(20) [] .pxToRem(30) [] 0;
        .region {
            padding-left: .pxToRem(30) [];
            padding-right: .pxToRem(20) [];
            font-size: .pxToRem(26) [];
            height: .pxToRem(66) [];
            line-height: .pxToRem(66) [];
            background: rgba(0, 0, 0, 0.05);
            border-top-left-radius: .pxToRem(33) [];
            border-bottom-left-radius: .pxToRem(33) [];
            .img {
                .sq(24);
                vertical-align: middle;
                margin-left: .pxToRem(10) [];
                line-height: 0;
            }
        }
        .search {
            flex: 1;
            display: flex;
            align-items: center;
            height: .pxToRem(66) [];
            line-height: .pxToRem(66) [];
            padding-left: .pxToRem(20) [];
            cursor: pointer;
            background: rgba(0, 0, 0, 0.05);
            border-top-right-radius: .pxToRem(33) [];
            border-bottom-right-radius: .pxToRem(33) [];
            .img {
                .sq(32);
                vertical-align: middle;
                line-height: 0;
            }
            .txt {
                padding-left: .pxToRem(10) [];
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.3);
            }
        }
    }
    flex-direction: column;
    width: 100%;
    .demo {
        position: fixed;
        top: 0;
        left: 0;
    }
    .swiper-box {
        padding: .pxToRem(20) [] .pxToRem(24) [];
        box-sizing: border-box;
        .swiper-container {
            width: 100%;
            height: auto;
            border-radius: .pxToRem(10) [];
        }
        .swiper-img {
            width: 100%;
            border-radius: .pxToRem(10) [];
        }
    }

    .member {
        // padding: 0 .pxToRem(20) [];
        .wrap {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            padding-bottom: .pxToRem(10) [];
        }
        .cell {
            text-align: center;
            position: relative;
            width: .pxToRem(110) [];
            height: .pxToRem(110) [];
            .cell-item {
                .base-center;
                .sq(110);
                background: #ffffff;
                box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
                border-radius: .pxToRem(75) [];
                border: .pxToRem(2) [] solid @theme_color_first;
                box-sizing: border-box;
                .img {
                    .base-center-x;
                    top: .pxToRem(20) [];
                    .sq(44);
                }
                .name {
                    .base-center-x;
                    bottom: .pxToRem(16) [];
                    width: 100%;
                    font-size: .pxToRem(20) [];
                    height: .pxToRem(26) [];
                    line-height: .pxToRem(26) [];
                    color: rgba(0, 0, 0, 0.9);
                }
            }
        }
    }
    .nav {
        padding: .pxToRem(19) [] 0;
        .wrap {
            display: flex;
            justify-content: center;
            .cell {
                position: relative;
                padding: 0 .pxToRem(55) [];
                &.active {
                    font-weight: bold;
                    &:before {
                        content: '';
                        .base-center-x;
                        bottom: .pxToRem(-22) [];
                        .sq(10);
                        border-radius: .pxToRem(10) [];
                        background: #f8c32f;
                    }
                    .txt {
                        color: rgba(0, 0, 0, 0.9);
                    }
                }
            }
            .txt {
                color: rgba(0, 0, 0, 0.5);
                font-size: .pxToRem(30) [];
                line-height: .pxToRem(50) [];
            }
            .search {
                width: .pxToRem(140) [];
                height: .pxToRem(50) [];
                border-radius: .pxToRem(25) [];
                background: #f7f8fa;
                text-align: center;
                line-height: .pxToRem(50) [];
                .img {
                    width: .pxToRem(26) [];
                    height: .pxToRem(26) [];
                    vertical-align: middle;
                }
                .txt {
                    padding-left: .pxToRem(10) [];
                    font-size: .pxToRem(26) [];
                    color: #999999;
                }
            }
        }
    }
    .list {
        padding: .pxToRem(20) [] .pxToRem(30) [] 0 .pxToRem(30) [];
        .wrap {
            .cell {
                display: flex;
                flex-direction: row;
                height: .pxToRem(280) [];
                margin-bottom: .pxToRem(20) [];
                box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
                border-radius: .pxToRem(40) [];
                background: white;
                .c-left {
                    margin-left: .pxToRem(30) [];
                    .img {
                        margin-top: .pxToRem(35) [];
                        width: .pxToRem(160) [];
                        height: .pxToRem(210) [];
                        border-radius: .pxToRem(16) [];
                    }
                }
                .c-center {
                    flex: 1;
                    margin-left: .pxToRem(30) [];
                    margin-top: .pxToRem(27) [];
                    position: relative;
                    .cchd {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: .pxToRem(48) [];
                        line-height: .pxToRem(48) [];
                        font-size: .pxToRem(32) [];
                        color: rgba(0, 0, 0, 0.9);
                        font-weight: bold;
                        display: flex;
                        .cinema {
                            height: .pxToRem(48) [];
                            line-height: .pxToRem(48) [];
                            .overflow(1);
                        }
                        .hint {
                            display: flex;
                            margin-top: .pxToRem(7) [];
                            margin-left: .pxToRem(20) [];
                            margin-right: .pxToRem(20) [];
                            height: .pxToRem(34) [];
                            line-height: .pxToRem(34) [];
                            box-sizing: border-box;
                            border: .pxToRem(2) [] solid #313131;
                            font-size: .pxToRem(20) [];
                            border-radius: .pxToRem(8) [];
                            padding: 0 .pxToRem(10) [];
                            white-space: nowrap;
                            .txt {
                                float: left;
                            }
                            .imax {
                                margin-left: .pxToRem(6) [];
                            }
                            &.highlight {
                                color: #f8c32f;
                                border: .pxToRem(2) [] solid #f8c32f;
                            }
                        }
                    }
                    .grade,
                    .director,
                    .lead,
                    .time {
                        position: absolute;
                        left: 0;
                        font-size: .pxToRem(24) [];
                        line-height: .pxToRem(36) [];
                        color: rgba(0, 0, 0, 0.5);
                    }
                    .grade,
                    .director,
                    .lead {
                        box-sizing: border-box;
                        padding-right: .pxToRem(20) [];
                        width: 100%;
                    }
                    .grade {
                        top: .pxToRem(68) [];
                        .grade-title {
                            margin-right: .pxToRem(8) [];
                        }
                        .tint:nth-child(1),
                        .tint:nth-child(2) {
                            color: #f7b500;
                            font-weight: bold;
                            font-size: .pxToRem(28) [];
                            margin-right: .pxToRem(32) [];
                        }
                        .tint:nth-child(1) {
                            margin-right: .pxToRem(4) [];
                        }
                    }
                    .director {
                        top: .pxToRem(107) [];
                    }
                    .lead {
                        top: .pxToRem(146) [];
                    }
                    .time {
                        top: .pxToRem(185) [];
                        .txt {
                            max-width: .pxToRem(350) [];
                        }
                    }
                    .txt {
                        display: inline-block;
                        overflow: hidden;
                        -o-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 100%;
                    }
                }
                .c-right {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: .pxToRem(150) [];
                    height: .pxToRem(64) [];
                    line-height: .pxToRem(64) [];
                    background: @theme_color_first;
                    border-radius: .pxToRem(100) [] 0 .pxToRem(40) [] 0;
                    text-align: center;
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.9);
                    &.pre-sale {
                        background: #000000;
                        color: #ffffff;
                    }
                }
            }
        }
    }
    .noList {
        text-align: center;
        margin-top: .pxToRem(100) [];
        color: rgba(153, 153, 153, 1);
        font-size: .pxToRem(30) [];
    }
}
</style>
